(() => {
  let refreshTimer = null;
  let activeRequest = null;

  const updateHeaderCount = (count) => {
    document.querySelectorAll('[data-hh-cart-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count < 1;
    });
  };

  const refresh = async () => {
    window.clearTimeout(refreshTimer);
    activeRequest?.abort();
    activeRequest = new AbortController();

    try {
      const rootUrl = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootUrl}cart.js`, {
        headers: { Accept: 'application/json' },
        signal: activeRequest.signal,
      });
      if (!response.ok) return;
      const cart = await response.json();
      updateHeaderCount(Number(cart.item_count) || 0);
    } catch (error) {
      if (error.name !== 'AbortError') console.error(error);
    }
  };

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 60);
  };

  window.HHCartFeedback = { refresh: scheduleRefresh };
  document.addEventListener('hh:cart-updated', scheduleRefresh);

  const subscribeToCart = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', subscribeToCart, { once: true });
  else subscribeToCart();
})();
